<template>
  <a-card>
    <a-descriptions
      title="Info Shift / Thông tin địa điểm làm việc"
      :column="1"
    >
      <!-- <a-descriptions-item label="Số ngày nghỉ tối đa">
        {{ workShift.limit }}
      </a-descriptions-item> -->
      <a-descriptions-item label="Weekekday / Ngày làm việc">
        <span v-for="(day, index) in dayInWeeks" :key="index">
          <span>
            {{ convertDayInWeekToNameDate(day) }}
            <span v-if="index < dayInWeeks.length - 1">,</span>
          </span>
        </span>
      </a-descriptions-item>
      <a-descriptions-item label="Duration / Số giờ làm việc">
        {{ workShift.duration }}
      </a-descriptions-item>
      <a-descriptions-item label="Working Time / Giờ làm việc">
        {{ workShift.startTime | formatTime }} -
        {{ workShift.endTime | formatTime }}
      </a-descriptions-item>
    </a-descriptions>
    <CollapseCard>
      <div slot="content">
        <a-alert
          v-if="workShift && workShift.id"
          banner
          type="info"
          style="white-space: pre-line; display: block;"
        >
          <div
            slot="message"
            v-if="workShift.description"
            v-html="workShift.description"
          ></div>
          <div slot="message" v-else>
            Empty
          </div>
        </a-alert>
      </div>
    </CollapseCard>
  </a-card>
</template>
<script>
import CollapseCard from "@/components/common/collapseCard";
import { dayOfWeeks } from "../../constant/default";
export default {
  components: { CollapseCard },
  props: {
    workShift: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      dayInWeeks: [],
    };
  },
  methods: {
    convertDayInWeekToNameDate(dayInWeek) {
      if (dayOfWeeks?.length > 0) {
        const index = dayOfWeeks.findIndex((e) => e.key === dayInWeek);
        if (index >= 0) {
          return dayOfWeeks[index].Title;
        }
      }

      return "Không có ngày";
    },
  },
  mounted() {
    if (this.workShift?.dayInWeeks) {
      this.dayInWeeks = JSON.parse(this.workShift.dayInWeeks);
    }
  },
};
</script>
<style lang="css" scoped></style>
